import { skipToken } from '@reduxjs/toolkit/query';
import {
  useGetAllEnterpriseQuery,
  useGetAllPlantsByEnterpriseListQuery,
  useGetAllPlantsQuery,
} from '../../../services/common';

export const useApiHelper = (
  enterprise: number | undefined
) => {
  const { data: listOfAllPlants } = useGetAllPlantsQuery();
  const { data: listOfEnterprises } =
    useGetAllEnterpriseQuery([1]);

  const { data: listOfPlants } =
    useGetAllPlantsByEnterpriseListQuery(
      enterprise ? [enterprise] : null ?? skipToken
    );

  const formattedListOfEnterprises = listOfEnterprises?.map(
    (ele) => ({
      value: ele.id,
      label: ele.companyName,
    })
  );
  const formattedListOfPlants = listOfPlants?.map(
    (ele) => ({
      value: ele.plantCode,
      label: `${ele.plantName} [${ele.plantCode}]`,
    })
  );
  const formattedListOfAllPlants = listOfAllPlants?.map(
    (ele) => ({
      value: ele.plantCode,
      label: `${ele.plantName} [${ele.plantCode}]`,
    })
  );

  return {
    listOfEnterprises: formattedListOfEnterprises,
    listOfPlants: formattedListOfPlants,
    listOfAllPlants: formattedListOfAllPlants,
  };
};
